/* global femcare, Swiper */

femcare.shared.slider = {

    init: function () {
        var $sliders = $('.slider');

        if ($sliders.length) {

            $sliders.each(function (index, element) {
                var $slider = $(element);
                var $slideCount = $slider.find('.slider__slide-count');
                var pageLocalized = $slideCount.attr('data-page-local') || '';
                var ofLocalized = $slideCount.attr('data-of-local') || ' / ';

                new Swiper($slider.find('.swiper-container')[0], {
                    lazy: true,
                    watchOverflow: true,
                    breakpoints: {
                        350: {
                            slidesPerView: 2,
                            slidesPerGroup: 2
                        },
                        600: {
                            slidesPerView: 3,
                            slidesPerGroup: 3
                        },
                        1200: {
                            slidesPerView: 4,
                            slidesPerGroup: 4
                        }
                    },
                    pagination: {
                        el: $slider.find('.swiper-pagination')[0],
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var hasSinglePage = total === 1;

                            return hasSinglePage ? '' : (pageLocalized + ' ' + current + ' ' + ofLocalized + ' ' + total);
                        }
                    }, navigation: {
                        nextEl: $slider.find('.slider__next')[0],
                        prevEl: $slider.find('.slider__previous')[0]
                    }
                });


            });


        }
    }
};
